import React, { useEffect } from 'react'
import './Rice.css'
import InfoContainer from '../../../../../components/InfoContainer'
import Breadcrumb from '../../../../../components/Breadcrum';

const servicesData = [
  {
    title: "1121 Creamy Sella Basmati Rice",
    description: (
      <>
        <ul>
          <li>Average Grain Length: 8.35 mm</li>
          <li>Broken Grain: {'< 1%'}</li>
          <li>Moisture: {'< 12%'}</li>
          <li>Purity: 94%</li>
          <li>Sortex: 100% Clean</li>
          <li>Damaged/Discolored Grains: Nill</li>
          <li>Black Grains: Nill</li>
        </ul>
      </>
    ),
    imageUrl: "./assets/img/agriculturalCommodities/1121-Creamy-Sella-1024x803.png"
  },
  {
    title: "1121 Golden Sella Basmati Rice",
    iconClass: "fas fa-archive",
    description: (
      <>
        <ul>
          <li>Average Grain Length: 8.40 mm</li>
          <li>Broken Grain:{' < 1%'}</li>
          <li>Moisture: {'< 12%'}</li>
          <li>Purity: 94%</li>
          <li>Sortex: 100% Clean</li>
          <li>Damaged/Discolored Grains: Nill</li>
          <li>Black Grains: Nill</li>
        </ul>
      </>
    ),
    imageUrl: "./assets/img/agriculturalCommodities/1121-Golden-1024x803.png"
  },
  {
    title: "1121 Steam Basmati Rice",
    iconClass: "fas fa-archive",
    description: (
      <>
        <ul>
          <li>Average Grain Length: 8.45 mm</li>
          <li>Broken Grain: {'< 1%'}</li>
          <li>Moisture: {'< 13%'}</li>
          <li>Purity: 94%</li>
          <li>Sortex: 100% Clean</li>
          <li>Damaged/Discolored Grains: Nill</li>
          <li>Black Grains: Nill</li>
        </ul>
      </>
    ),
    imageUrl: "./assets/img/agriculturalCommodities/1121-Steam-1024x803.png"
  },
  {
    title: "1121 Raw Basmati Rice",
    iconClass: "fas fa-archive",
    description: (
      <>
        <ul>
          <li>Average Grain Length: 8.35 mm</li>
          <li>Broken Grain: {'< 1%'}</li>
          <li>Moisture: {'< 12%'}</li>
          <li>Purity: 94%</li>
          <li>Sortex: 100% Clean</li>
          <li>Damaged/Discolored Grains: Nill</li>
          <li>Black Grains: Nill</li>
        </ul>
      </>
    ),
    imageUrl: "./assets/img/agriculturalCommodities/1121-Raw-1024x803.png"
  }
];

export default function Rice() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title="Rice"
        backgroundImage={'./assets/img/contact-banner.png'}
        height="40vh"
      />
      {/* <InfoContainer 
        title='1121 Basmati Rice' 
        paragraph1='1121 Basmati Rice is a hybrid extra long grain rice variety grown in Haryana, Punjab & Uttar Pradesh region of India. It is a thin rice grain with average grain length of 8.30 MM – 8.45 MM & the elongation ratio of the grain is 3 times if cooked well. The main difference between 1121 Basmati Rice and other Basmati Rice lies in the length of the grain. It is the longest basmati grain in the world before and after cooking. The grain of 1121 Basmati rice is thinner than other Basmati Rice.' 
      /> */}
      <section className="main-services rice my-5">
        <div className="container">
          <div className="row">
            {servicesData.map((service, index) => (
              <div key={index} className={`col-lg-12 ${index === 2 ? 'last-service' : ''} ${index % 2 == 0 ? 'even' : 'odd'}`} >
                <div className="service-item">
                  <div className="row">
                    {/* Conditionally switch the order of image and text */}
                    {index % 2 === 0 ? (
                      <>
                        <div className="col-lg-6 even">
                          <div className="left-image">
                            <img src={service.imageUrl} alt={service.title} />
                          </div>
                        </div>
                        <div className="col-lg-6 align-self-center">
                          <div className="right-text-content">
                            <i className={service.iconClass}></i>
                            <h4>{service.title}</h4>
                            {service.description}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-lg-6 align-self-center odd">
                          <div className="right-text-content">
                            <i className={service.iconClass}></i>
                            <h4>{service.title}</h4>
                            {service.description}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="left-image">
                            <img src={service.imageUrl} alt={service.title} />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* <InfoContainer 
  title="About 1121 Basmati Rice" 
  paragraph1="1121 Basmati rice is a premium long-grain rice variety revered for its exquisite quality, remarkable fragrance, and delicate texture. With each grain measuring between 8.30 to 8.45 mm in length, this slender and elongated rice variety is widely recognized for its distinct attributes." 
  paragraph2="One of the most captivating features of 1121 Basmati rice is its enticing aroma. As the grains cook, they release a fragrant scent that can be likened to a blend of pandan leaves and popcorn." 
  paragraph3="Cultivated in the fertile lands of the Indian subcontinent, 1121 Basmati rice benefits from the region's unique climate and soil conditions. The careful cultivation and harvesting processes ensure that only the finest grains meet the market's exacting standards." 
/> */}

    </>
  );
}
